import React from "react";
import { cn } from "@/lib/utils";

export const MetricCard: React.FC<{
  title: string;
  value: string | number;
  icon: React.ReactNode;
  className?: string;
}> = ({ title, value, icon, className }) => {
  return (
    <div className={cn("p-6 rounded-xl bg-card text-card-foreground border border-border shadow-sm", className)}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-muted-foreground">{title}</p>
          <p className="text-2xl font-bold mt-1">
            {typeof value === "number" ? value.toLocaleString() : value}
          </p>
        </div>
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
          {icon}
        </div>
      </div>
    </div>
  );
};